module.exports = __webpack_public_path__ + "img/tooltip-perceived.c1ac2922.svg";